import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import DangerousIcon from "@mui/icons-material/Dangerous";
import Box from "@mui/material/Box";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const useStyles = makeStyles(styles);
const permissionscolumn = [
  {
    field: "pmS_ID",
    headerName: "Permission ID",
    width: 150,
    headerAlign: "center",
    cellClassName: "center",
  },
  {
    field: "pmS_NAME",
    headerName: "Tên",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "ctL_NAME",
    headerName: "Controller",
    width: 300,
    headerAlign: "center",
  },
];
export default function Permission() {
  const classes = useStyles();
  const [listpermission, setListpermission] = React.useState([]);
  const [openthempermission, setOpenpermission] = React.useState(false);
  const [openupdatepermission, setOpenupdatepermission] = React.useState(false);
  const [openxoapermission, setOpenxoapermission] = React.useState(false);
  const [openwarning, setOpenWarning] = React.useState(false);
  const [openUpLoadFile, setOpenUpLoadFile] = React.useState(false);
  const [warrningContent, setWarrningContent] = React.useState("");
  const [deleteLoaiPermission, setDeleteLoaiPermission] = React.useState("");
  const [deleteId, setDeleteId] = React.useState("");
  const [value, setValue] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(50);

  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");

  const [openUpLoadTable, setOpenUpLoadTable] = React.useState(false);
  const [updateObj, setUpdateObj] = React.useState({});
  const [addObj, setAddObj] = React.useState({});
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  // Xử lú API
  const getListPermission = () => {
    var url = Config.backend + "/api/permissions/permissions";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setListpermission(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const themPermission = () => {
    console.log(addObj);
    var url = Config.backend + "/api/Permissions/thempermission";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({
        ctL_NAME: addObj.ctL_NAME,
        ghI_CHU: addObj.ghI_CHU,
        pmS_NAME: addObj.pmS_NAME,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleClose();
        getListPermission();
        showNotification("Thêm permission thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleClose();
        console.error("Error fetching data: ", error);
        showNotification("Thêm permission thất bại", DangerousIcon, "danger");
      });
  };

  const suaPermission = () => {
    var url =
      Config.backend +
      "/api/Permissions/capnhatpermission?pms_id=" +
      updateObj.pmS_ID;
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({
        ctL_NAME: updateObj.ctL_NAME,
        ghI_CHU: updateObj.ghI_CHU,
        pmS_NAME: updateObj.pmS_NAME,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleupdateClose();
        getListPermission();
        showNotification("Cập nhật permission thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleupdateClose();
        console.error("Error fetching data: ", error);
        showNotification(
          "Cập nhật permission thất bại",
          DangerousIcon,
          "danger"
        );
      });
  };

  const xoaLoaiPermission = () => {
    var url =
      Config.backend + "/api/Permissions/xoapermission?pms_id=" + deleteId;
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handlexoaClose();
        getListPermission();
        showNotification("Xóa permission thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handlexoaClose();
        console.error("Error fetching data: ", error);
        showNotification("Xóa permission thất bại", DangerousIcon, "danger");
      });
  };

  const uploadPermission = () => {
    if (value.length < 1) {
      setWarrningContent("Chưa upload file !!!");
      setOpenWarning(true);
    } else {
      console.log(JSON.stringify(value));
    }
  };

  const uploadData = () => {
    handleCloseUploadTable();
  };

  const openThemLoaiPermission = () => {
    setOpenpermission(true);
  };

  const openXoaLoaiPermission = () => {
    if (deleteId === "") {
      setWarrningContent("Bạn chưa chọn  permission cần xóa !!!");
      setOpenWarning(true);
    } else {
      setOpenxoapermission(true);
    }
  };

  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setIcon(icon);
    setColor(color);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };

  const handleupdateClose = () => {
    setOpenupdatepermission(false);
    setUpdateObj({});
  };
  const handlexoaClose = () => {
    setOpenxoapermission(false);
    setDeleteLoaiPermission("");
    setDeleteId("");
  };
  const handleClose = () => setOpenpermission(false);
  const handleCloseWarning = () => setOpenWarning(false);
  const handleCloseUpload = () => {
    setOpenUpLoadFile(false);
  };
  const handleCloseUploadTable = () => {
    setOpenUpLoadTable(false);
    setValue([]);
  };

  React.useEffect(() => {
    getListPermission();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "12%", marginTop: 5 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 25 }}
            onClick={openThemLoaiPermission}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "10%", marginTop: 5, marginLeft: 10 }}>
          <Button
            variant="contained"
            onClick={openXoaLoaiPermission}
            style={{ height: 25 }}
            color="warning"
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.pmS_ID}
            rows={listpermission}
            columns={permissionscolumn}
            checkboxSelection={false}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setUpdateObj(params.row);
                event.defaultMuiPrevented = true;
                setOpenupdatepermission(true);
              }
            }}
            onRowClick={(params, event) => {
              setDeleteLoaiPermission(params.row.pmS_NAME);
              setDeleteId(params.row.pmS_ID);
              event.defaultMuiPrevented = true;
            }}
            rowHeight={30}
            headerHeight={35}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color={color}
            icon={icon}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridItem>

      {/* S--Thêm  permission--S */}
      <Modal
        open={openthempermission}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <h6
                    className={classes.cardTitleWhite}
                    style={{ marginTop: "-5px" }}
                  >
                    Thêm permission
                  </h6>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên permission"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              pmS_NAME: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên controller"
                          variant="outlined"
                          size="small"
                          //   inputProps={{ maxLength: 3 }}
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              ctL_NAME: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Ghi chú"
                          variant="outlined"
                          size="small"
                          multiline
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              ghI_CHU: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ height: 25 }}
                      onClick={themPermission}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={handleClose}
                      style={{ height: 25, marginLeft: 10 }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Thêm  permission--E */}
      {/* S--Sửa  permission--S */}
      <Modal
        open={openupdatepermission}
        onClose={handleupdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Cập nhật permission
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleupdateClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên permission"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.pmS_NAME == null ? "" : updateObj.pmS_NAME
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              pmS_NAME: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên controller"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.ctL_NAME == null ? "" : updateObj.ctL_NAME
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              ctL_NAME: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Ghi chú"
                          variant="outlined"
                          size="small"
                          multiline
                          value={
                            updateObj.ghI_CHU == null ? "" : updateObj.ghI_CHU
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              ghI_CHU: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ height: 25 }}
                      onClick={suaPermission}
                    >
                      Cập nhật
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleupdateClose}
                      style={{ height: 25, marginLeft: 10 }}
                      color="warning"
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Sửa  permission--E */}

      {/* S--Xóa  permission--S */}
      <Modal
        open={openxoapermission}
        onClose={handlexoaClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Xóa permission
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handlexoaClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>
                        Bạn có muốn xóa permission{" "}
                        <strong>{deleteLoaiPermission}</strong> ?
                      </h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={xoaLoaiPermission}
                      style={{ color: "#fff", backgroundColor: "#BB2124" }}
                    >
                      Xóa
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlexoaClose}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Xóa  permission--E */}

      {/* S--Warning modal--S */}
      <Modal
        open={openwarning}
        onClose={handleCloseWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Warning
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>{warrningContent}</h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleCloseWarning}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Warning permission--E */}

      {/* S--Upload modal--S */}
      <Modal
        open={openUpLoadFile}
        onClose={handleCloseUpload}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Upload
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={uploadPermission}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleCloseUpload}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Upload  permission--E */}
      {/* S--Upload modal--S */}
      <Modal
        open={openUpLoadTable}
        onClose={handleCloseUploadTable}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Upload
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <div style={{ height: 400, width: "100%" }}>
                      <DataGrid
                        getRowId={(row) => row.id}
                        rows={value}
                        columns={value}
                        checkboxSelection={false}
                        rowHeight={30}
                        headerHeight={35}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            py: 1,
                          },
                          [`& .center`]: {
                            justifyContent: "center !important",
                          },
                        }}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        rowsPerPageOptions={[20, 50, 100]}
                        pagination
                      />
                    </div>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={uploadData}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleCloseUploadTable}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Upload  roles--E */}
    </GridContainer>
  );
}
